import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";
import { DefaultPartnerLayout } from "@App/Layouts/Partner/DefaultPartnerLayout";
import { Home } from "@App/Pages/Partner/DHL/Home";
import { DefaultRoutes } from "@App/routes/Partner/DefaultRoutes";

export function DHL() {
  const { config } = useOrganizationConfig();

  return (
    <DefaultRoutes
      layout={
        <div className="font-sans">
          <DefaultPartnerLayout
            logos={config.navbar.logos}
            backToPartnerButton={config.navbar.backToPartnerButton}
          />
        </div>
      }
      home={<Home onSubmit={() => null} />}
    />
  );
}
